/**
 * @generated SignedSource<<315d6b520f1737bf4a223de5f0e90fd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type CreateWidgetCalendarOverviewInput = {
  calendarIds: ReadonlyArray<string>;
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
};
export type WACalendarOverviewMutation$variables = {
  input: CreateWidgetCalendarOverviewInput;
  storecastId: string;
};
export type WACalendarOverviewMutation$data = {
  readonly dashboard: {
    readonly createWidgetCalendarOverview: {
      readonly id: string;
    };
  };
};
export type WACalendarOverviewMutation = {
  response: WACalendarOverviewMutation$data;
  variables: WACalendarOverviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetCalendarOverview",
        "kind": "LinkedField",
        "name": "createWidgetCalendarOverview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WACalendarOverviewMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WACalendarOverviewMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0d85a45c97f3b732925e6c3cc0f518d0",
    "id": null,
    "metadata": {},
    "name": "WACalendarOverviewMutation",
    "operationKind": "mutation",
    "text": "mutation WACalendarOverviewMutation(\n  $storecastId: ID!\n  $input: CreateWidgetCalendarOverviewInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetCalendarOverview(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ef871039ec71d82330bdc61d9851c6b";

export default node;
